<template>
    <div class="google-container">
        <div class="google-card">
            <div v-if="statusReturn === 'ok'">
                <div class="google-logos">
                    <LogoSection />
                </div>
                <template v-if="loading">
                    <div v-if="totalEventsCreated >= 1" class="title text-center">
                        Sincronizando <span class="google-total">{{ totalEventsCreated }}</span> de <span
                            class="google-total">{{
                                totalEvents }}</span>
                    </div>
                    <div v-else>Estabelecendo conexão com o Google Agenda...</div>
                    <br>
                    <Loading type="line" :center="true" />
                    <AnimatedPhrase
                        :phrases="['Aguarde...', 'Isso pode levar alguns ou vários minutos...', 'Não feche ou atualize a página...']" />
                </template>

                <template v-else>
                    <div>
                        <div class="google-status google-success">Conexão Realizada com Sucesso</div>
                        <span class="title back-link" @click="back()">Voltar</span>
                    </div>
                </template>
            </div>

            <div v-else-if="statusReturn === 'disconnect'">
                <div class="google-logos">
                    <LogoSection />
                </div>
                <Alert type="warning">
                    <span class="title">
                        Ao se desconectar, todos os calendários criados pelo Nixloc serão removidos. Deseja continuar?
                    </span>
                </Alert>
                <br />
                <Button _key="btnBack" classIcon="fa-solid fa-arrow-left" type="info" size="small" :clicked="back" />
                <Button _key="btnDisconnect" title="Sim, confirmar" backGroundColor="#EF294B" color="white" size="medim"
                    :clicked="disconnect" />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorsGoogle from '../../../components/modules/shared/google-calendar/ErrorsGoogle.vue'
import AnimatedPhrase from "@nixweb/nixloc-ui/src/component/layout/AnimatedPhrase";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
    name: "IntegrationReturn",
    components: {
        AnimatedPhrase,
        Alert,
        Button,
        Loading,
        ErrorsGoogle,
        LogoSection: {
            functional: true,
            render(h) {
                return h("div", { class: "google-logos", ErrorsGoogle }, [
                    h("div", { class: "google-logo" }, [
                        h("img", {
                            attrs: {
                                src: "https://www.gstatic.com/images/branding/product/1x/calendar_48dp.png",
                                alt: "Google Calendar"
                            }
                        })
                    ]),
                    h("div", { class: "google-plus" }, "+"),
                    h("div", [
                        h("img", {
                            class: "google-logo-nix",
                            attrs: {
                                src: "https://nixloc.com.br/wp-content/themes/nixloc/shared/images/logo/nixloc.svg",
                                alt: "Nixloc"
                            }
                        })
                    ])
                ]);
            }
        }
    },
    data() {
        return {
            urlDisconnect: "/api/v1/google/disconnect",
            urlSynchronize: "/api/v1/google/synchronize-calendar",
            urlCreateEvent: "/api/v1/google/create-event",
            statusReturn: this.$route.params.statusReturn,
            countdown: 10,
            timer: null,
            error: false,
            errors: [],
            loading: true,
            totalEvents: 0,
            totalEventsCreated: 0,
        };
    },
    mounted() {
        this.updateStatusGoogle(true);
        if (this.statusReturn === "ok")
            this.synchronize();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    computed: {
        ...mapState("user", ["userLogged"]),
        ...mapGetters("user", ["hasRule"]),
    },
    methods: {
        ...mapMutations("user", ["updateStatusGoogle"]),
        ...mapMutations("generic", ["removeLoading"]),
        ...mapActions("generic", ["postApi"]),
        synchronize() {
            let params = {
                url: this.urlSynchronize,
                obj: {
                    firstSynchro: true,
                    userId: this.userLogged.user.id,
                    showJob: true,
                    showDelivery: this.hasRule('Operational') || this.hasRule('Rental'),
                    showPeriod: false,
                    showProgress: false,
                    showDevolution: this.hasRule('Operational') || this.hasRule('Rental'),
                    showMaintenance: this.hasRule('Maintenance'),
                    notifications: [
                        { type: "popup", time: 10, unit: "minutes" },
                        { type: "popup", time: 1, unit: "hours" }],
                },
                notNotifyToast: true
            };
            this.postApi(params).then((response) => {
                this.totalEvents = response.content.length;

                if (this.totalEvents == 0) {
                    this.totalEventsCreated = 0;
                    this.totalEvents = 0;
                    this.loading = false;
                }

                let self = this;
                response.content.forEach((event, index) => {
                    setTimeout(() => {
                        self.createEvent(event);
                    }, index * 1000);
                });

                this.removeLoading(["synchronize"]);
            });
        },
        createEvent(event) {
            let params = {
                url: this.urlCreateEvent,
                obj: event,
                notNotifyToast: true
            };
            this.postApi(params).then(response => {
                if (response.success) {
                    this.totalEventsCreated++;
                    if (this.totalEventsCreated == this.totalEvents) {
                        this.totalEventsCreated = 0;
                        this.totalEvents = 0;
                        this.loading = false;
                    }
                }
            });
        },
        back() {
            let self = this;
            setTimeout(function () {
                if (self.error) self.disconnect();
                self.removeLoading(["btnBack"]);
                self.$router.replace({ name: "calendar" });
            }, 300);
        },
        disconnect() {
            let params = {
                url: this.urlDisconnect,
                obj: { id: this.userLogged.user.id },
                notNotifyToast: true
            };
            this.postApi(params).then((response) => {
                this.updateStatusGoogle(false);
                this.back();
            });
        }
    }
};
</script>

<style scoped>
.google-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f0f2f5;
}

.google-card {
    background: white;
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 4px 100px rgba(0, 0, 0, 0);
    width: 500px;
    text-align: center;
}

.google-card h4 {
    color: #2d3436;
    margin-bottom: 10px;
}

.google-card p {
    color: #636e72;
    margin-bottom: 20px;
}

.google-logos {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.google-logo-nix {
    width: 120px;
}

.google-logo img {
    width: 48px;
    height: 48px;
}

.google-plus {
    font-size: 40px;
    margin: 0 30px;
    color: #0984e3;
}

.google-status {
    font-size: 16px;
    padding: 3px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.google-success {
    background-color: #f6ffed;
    color: #52c41a;
    border: 1px solid #d7f4be;
}

.google-danger {
    background-color: #fff1f0;
    color: red;
    border: 1px solid #ffa39e;
}

.back-link {
    cursor: pointer;
}

.google-total {
    font-size: 16px;
}
</style>